import {isFunction} from 'lodash';
import {Directive, HostListener} from '@angular/core';

@Directive({
    selector: '[wizard-prev]'
})
export class WizardPrev {

    private prevLoader: Function;

    public setupPrevLoader(loader: Function) {
        this.prevLoader = loader;
    }

    @HostListener('click') onClick() {
        if (isFunction(this.prevLoader)) {
            this.prevLoader();
        }
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/wizard/wizard.prev.ts